import { render } from "./TemplateIndex.vue?vue&type=template&id=dfa210cc"
import script from "./TemplateIndex.vue?vue&type=script&lang=js"
export * from "./TemplateIndex.vue?vue&type=script&lang=js"

import "./TemplateIndex.vue?vue&type=style&index=0&id=dfa210cc&lang=css"

import exportComponent from "/home/forge/somethingred.j20.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__